import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { VenueService } from './venue.service';
import { VenueModel } from './venue.model';

@Injectable({
  providedIn: 'root',
})
export class VenueResolver {
  constructor(private service: VenueService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<VenueModel> {
    return this.service.getById(route.paramMap.get('id') || '').pipe(map((venue) => venue.data));
  }
}
